// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__F-iRF","logo":"Footer_logo__AA3iF"};